module.exports = __webpack_public_path__ + "static/media/bandai.6dc4e629.png";